import classNames from 'classnames';
import styles from './Logo.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';

export interface LogoProps {
	className?: string;
	heading: string;
	desktopLogo: {
		url: string;
	};
	mobileLogo: {
		url: string;
	};
}

export const UI_Logo = ({ className, heading, desktopLogo, mobileLogo }: LogoProps) => (
	<UI_Link className={classNames(styles.Logo, className)} url="/">
		{desktopLogo && <UI_Picture url={desktopLogo.url} altText={heading} className={styles.Logo_desktop} sizes="189px" imageCropping="contain" />}
		{mobileLogo && <UI_Picture url={mobileLogo.url} altText={heading} className={styles.Logo_mobile} sizes="135px" imageCropping="contain" />}
	</UI_Link>
);
